export default __webpack_public_path__ + "static/media/bg.938b7574.png";